import {
  FormControlLabel,
  Switch,
  Box,
  Button,
  Typography,
} from '@mui/material'
import React, { useContext, useState } from 'react'
import API from '../../../../services/API'
import { IncidentContext } from './ReportIncident'

const Step8 = () => {
  const { formValues, setFormValues, setTab } = useContext(IncidentContext)
  const [clinical, setClinical] = useState(false)
  const [isSafeguarding, setIsSafeguarding] = useState(false)
  const [cprUsed, setCPRused] = useState(false)
  const [controlledDrugs, setControlledDrugs] = useState(false)
  const [manHandling, setManHandling] = useState(false)
  const [ipc, setIPC] = useState(false)
  const [sharps, setSharps] = useState(false)

  const handleSubmit = (e) => {
    e.preventDefault()
    setFormValues((prev) => ({
      ...prev,
      clinical,
      isSafeguarding,
      cprUsed,
      controlledDrugs,
      manHandling,
      ipc,
      sharps,
    }))
    API.post('/incident', {
      incidentDate: formValues.incidentDate,
      incidentType: formValues.incidentType,
      incidentLocation: formValues.incidentLocation,
      description: formValues.description,
      initialActions: formValues.initialActions,
      relatedAsset: formValues.assetID,
      vehiclesInvolved: formValues.selectedVehicles ?? [],
      files: formValues.files,
      relatedMedsBag: formValues.relatedMedsBag,
      relatedMedicines: (formValues?.drugsToRemove ?? []).map((x) => x._id),
      medicinesInvolvedNoAction: (formValues?.medicinesInvolvedNoAction ?? []).map(
        (x) => x._id,
      ),
      peopleInvolved: (formValues.peopleInvolved ?? []).map((person) => ({
        firstName: person.firstName,
        lastName: person.lastName,
        email: person.email,
        phone: person.phone,
        employee: person.employee?._id ?? person.employee ?? null,
      })),
      hiddenFrom: formValues.hiddenFrom ?? [],
      clinical,
      isSafeguarding,
      cprUsed,
      controlledDrugs,
      manHandling,
      ipc,
      sharps,
    })
      .then((res) => {
        res.status === 200 && setTab('submitted')
      })
      .catch((e) => {
        // setTab({submitError: e.message})
      })
    // setTab((prev) => prev + 1)
    window.scrollTo(0, 0)
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      gap={2}
      component="form"
      onSubmit={handleSubmit}
    >
      <Typography variant="title2" fontSize="1rem">
        Incident Characteristics
      </Typography>
      <Typography variant="caption" color="text.secondary">
        These flags route the incident to the right governance reviews.
      </Typography>
      <FormControlLabel
        control={
          <Switch
            checked={clinical}
            onChange={(e) => setClinical(e.target.checked)}
          />
        }
        label="Is this a clinical incident?"
      />
      <FormControlLabel
        control={
          <Switch
            checked={isSafeguarding}
            onChange={(e) => setIsSafeguarding(e.target.checked)}
          />
        }
        label="Is this a safeguarding incident?"
      />
      <FormControlLabel
        control={
          <Switch
            checked={cprUsed}
            onChange={(e) => setCPRused(e.target.checked)}
          />
        }
        label="Was CPR used?"
      />
      <FormControlLabel
        control={
          <Switch
            checked={controlledDrugs}
            onChange={(e) => setControlledDrugs(e.target.checked)}
          />
        }
        label="Does this incident involve Controlled Drugs?"
      />
      <FormControlLabel
        control={
          <Switch
            checked={manHandling}
            onChange={(e) => setManHandling(e.target.checked)}
          />
        }
        label="Is this a Manual Handling Incident?"
      />
      <FormControlLabel
        control={
          <Switch checked={ipc} onChange={(e) => setIPC(e.target.checked)} />
        }
        label="Does this incident involve Infection, Prevention and Control?"
      />
      <FormControlLabel
        control={
          <Switch
            checked={sharps}
            onChange={(e) => setSharps(e.target.checked)}
          />
        }
        label="Is this a sharps / needlestick incident?"
      />
      <Box display="flex" gap={1} justifyContent="flex-end">
        <Button
          variant="outlined"
          color="primary"
          onClick={() => setTab((prev) => prev - 1)}
        >
          Previous
        </Button>
        <Button variant="contained" color="success" type="submit">
          Submit
        </Button>
      </Box>
    </Box>
  )
}

export default Step8
